import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bb_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("bb_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return { mfaRequired: true, challengeToken: data.challenge_token };
    localStorage.setItem("bb_token", data.token);
    setUser(data.user);
    return { mfaRequired: false };
  };

  const verifyMfa = async (challengeToken, code) => {
    const { data } = await api.post("/auth/mfa/verify", { challenge_token: challengeToken, code });
    localStorage.setItem("bb_token", data.token);
    setUser(data.user);
    return data;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = () => { localStorage.removeItem("bb_token"); setUser(null); };

  const value = useMemo(() => ({ user, loading, login, verifyMfa, refreshUser, logout }), [user, loading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
